<div class="modal-body vtr-modal-cancel" role="dialog">

	<h1 id="hwscan-cancel-modal-title" class="title" role="heading">{{ 'hardwareScan.attention' | translate }}</h1>

	<p id="hwscan-cancel-modal-description" role="text">{{ description }}</p>
	<p id="hwscan-cancel-modal-confirm-message" *ngIf="isInCountdown" role="text">{{ 'hardwareScan.cancelTextPrompt' | translate }}</p>

	<!-- This is the regular button which is shown during the cancelation countdown and which is responsible for cancel the scan/rbs process if the user clicks on it
		NOTICE: It's mandatory to use a <div class="row"> here to prevent that the button could be clicked wrongly (in its near instead of itself), caused by its 'button box' internal div-->
	<div class="row line-separator">
		<div class="col" *ngIf="!loading">
			<div class="row button-row">
				<vtr-material-button *ngIf="isInCountdown; else noCountdown"
					linkId="hwscan-cancel-modal-yes-btn"
					label="{{ 'hardwareScan.yes' | translate | uppercase }} ({{ secondsCountdown }})"
					tooltipText ="{{ 'hardwareScan.yes' | translate }} ({{ secondsCountdown }})"
					(buttonClick)="onAgree()"
					heightSize="lg">
				</vtr-material-button>

				<ng-template #noCountdown>
					<vtr-material-button
						#cancel_modal_ok
						linkId="hwscan-cancel-modal-ok-btn"
						[label]="'hardwareScan.ok' | translate | uppercase"
						[tooltipText] ="'hardwareScan.ok' | translate"
						(buttonClick)="closeModal()"
						heightSize="lg">
					</vtr-material-button>
				</ng-template>
			</div>
		</div>

		<div class="col loading" *ngIf="loading">
			<fa-icon
				placement="auto"
				role="img"
				[attr.aria-label]="('hardwareScan.cancelMayTakeSomeTime' | translate)"
				[spin]="true"
				[icon]="['fal', 'circle-notch']"
				container="body"
				[autofocus]=true
			></fa-icon>
		</div>
	</div>

	<div class="btn-modal-close" *ngIf="isInCountdown">
		<vtr-ui-close-button
			linkId="hwscan-cancel-modal-close-btn"
			(clickClose)="closeModal()">
		</vtr-ui-close-button>
	</div>
</div>
